import React from 'react';
import BusSearchResults from './BusSearchResults';

function BusSearchResultsPage() {
  return (
    <section className="bus-search-page-container">
      <BusSearchResults />
    </section>
  );
}

export default BusSearchResultsPage;
